import { AppRoutes } from 'config/routes';

export interface BreadcrumbsProps {
  id: number;
  path: string;
  title: string;
}

export interface IRoute {
  title: string;
  icon?: JSX.Element;
}

export type ItemRender = (
  route: IRoute,
  params: Record<string, any>,
  routes: IRoute[],
  paths: string[],
) => JSX.Element;

const { Home, Employees } = AppRoutes.Dashboard;

export const employeeRoutes: BreadcrumbsProps[] = [
  {
    id: 0,
    path: Home + Employees.Home,
    title: 'Employee management',
  },
  {
    id: 1,
    path: Home + Employees.Home,
    title: '',
  },
];